import _regeneratorRuntime from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//

import AvueSelectTemplateFactory from "../../../service/AvueSelectTemplateService/AvueSelectTemplateFactory";
export default {
  name: 'AvueSelectTemplate',
  model: {
    prop: 'value',
    // 默认是value
    event: 'avueSelect' // 默认是input
  },

  props: {
    multiple: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    value: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    /**
     *
     * */
    placeholder: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    /**
     * 业务类型
     * */
    businessTypeKey: {
      type: String,
      default: function _default() {
        return 'supply';
      }
    },
    /**
     * 字典类型
     * */
    dictType: {
      type: String,
      default: function _default() {
        return 'type';
      }
    },
    /**
     * 字典来源
     * */
    dictSource: {
      type: String,
      default: function _default() {
        return undefined;
      }
    }
  },
  data: function data() {
    return {
      canChange: false,
      formModel: [],
      dic: []
    };
  },
  mounted: function mounted() {
    this.initDictData();
  },
  watch: {
    value: function value(newValue, oldValue) {
      if (this.multiple === true) {
        if (newValue.length === 0 && oldValue.length > 0) {
          this.formModel = [];
        }
      } else {}
    }
  },
  methods: {
    /**
     * 可以改变下拉框内容了
     * */
    canChangeSelect: function canChangeSelect() {
      this.canChange = true;
    },
    initDictData: function () {
      var _initDictData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var avueSelectTemplateService, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                avueSelectTemplateService = AvueSelectTemplateFactory.newAvueSelectTemplateService(this.businessTypeKey);
                _context.next = 3;
                return avueSelectTemplateService.queryDictData(this.dictType, this.dictSource);
              case 3:
                result = _context.sent;
                this.dic = result;
                this.formModel = this.getEmitValue(this.value);
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function initDictData() {
        return _initDictData.apply(this, arguments);
      }
      return initDictData;
    }(),
    /**
     * emit的值
     * */
    getEmitValue: function getEmitValue(value) {
      var tempValue = this.canChange === false ? this.value : value;
      if (this.multiple === true && !Array.isArray(tempValue)) {
        // 支持多选，但value是字符串
        return [];
      } else {
        return tempValue;
      }
    },
    changeSelect: function changeSelect($event) {
      if (this.multiple === true && $event.value.length === 0) {
        this.$refs.SelectRef.checkAll = false;
      }
      var emitValue = this.getEmitValue($event.value);
      this.$emit('avueSelect', emitValue);
    }
  }
};